import { useState } from 'react';
import { useMutation, useQuery } from 'urql';
import PageHeader from '@/components/common/PageHeader.jsx';
import Field from '@/components/common/Field.jsx';
import StickyActions from '@/components/common/StickyActions.jsx';
import EmptyState from '@/components/common/EmptyState.jsx';
import { PORTAL_TICKET, PORTAL_AGREGAR_COMENTARIO } from './gql.js';

export default function PortalTicketDetailPage() {
  const [clienteId, setClienteId] = useState('');
  const [ticketId, setTicketId] = useState('');
  const [submitted, setSubmitted] = useState(null);
  const [comentario, setComentario] = useState('');
  const [result] = useQuery({ query: PORTAL_TICKET, variables: submitted ?? undefined, pause: !submitted });
  const [, agregarComentario] = useMutation(PORTAL_AGREGAR_COMENTARIO);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!clienteId || !ticketId) {
      alert('Ingresá cliente y ticket');
      return;
    }
    setSubmitted({ clienteId, id: ticketId });
  };

  const portalTicket = result.data?.portalTicket;
  const ticket = portalTicket?.ticket;

  const handleAddComment = async (event) => {
    event.preventDefault();
    if (!comentario.trim() || !ticket) return;
    const resultMutation = await agregarComentario({ input: { ticketId: ticket.id, mensaje: comentario } });
    if (resultMutation.error) {
      alert(resultMutation.error.message);
    } else {
      setComentario('');
      setSubmitted({ clienteId, id: ticket.id });
    }
  };

  return (
    <div className="w-full">
      <PageHeader title="Detalle de ticket" subtitle="Seguimiento de reclamo desde el portal" />
      <form onSubmit={handleSubmit} className="mx-auto mt-6 grid w-full max-w-[700px] grid-cols-12 gap-4">
        <div className="col-span-12 sm:col-span-6">
          <Field label="Cliente" htmlFor="clientePortal" required>
            <input
              id="clientePortal"
              type="number"
              value={clienteId}
              onChange={event => setClienteId(event.target.value)}
              className="w-full rounded-xl border border-[rgba(var(--border),0.6)] bg-[rgba(var(--subpanel),0.6)] px-3 py-2 text-sm text-[rgb(var(--fg))] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
            />
          </Field>
        </div>
        <div className="col-span-12 sm:col-span-6">
          <Field label="Ticket" htmlFor="ticketPortal" required>
            <input
              id="ticketPortal"
              type="number"
              value={ticketId}
              onChange={event => setTicketId(event.target.value)}
              className="w-full rounded-xl border border-[rgba(var(--border),0.6)] bg-[rgba(var(--subpanel),0.6)] px-3 py-2 text-sm text-[rgb(var(--fg))] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
            />
          </Field>
        </div>
        <div className="col-span-12 flex justify-end">
          <button
            type="submit"
            className="rounded-xl bg-[rgb(var(--brand))] px-4 py-2 text-sm font-semibold text-white shadow focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
          >
            Buscar ticket
          </button>
        </div>
      </form>

      <section className="mx-auto mt-6 w-full max-w-[900px] space-y-6">
        {!ticket ? (
          <EmptyState title="Sin ticket" description="Ingresá los datos y consultá el estado de tu reclamo." />
        ) : (
          <div className="rounded-2xl border border-[rgba(var(--border),0.6)] bg-[rgba(var(--panel),0.98)] p-6 shadow-xl">
            <h2 className="text-lg font-semibold text-[rgb(var(--fg))]">{ticket.asunto}</h2>
            <p className="mt-2 text-sm text-[rgba(var(--muted),0.95)]">{ticket.descripcion || 'Sin descripción'}</p>
            <p className="mt-4 text-xs uppercase tracking-wide text-[rgba(var(--muted),0.9)]">Estado: {ticket.estado}</p>
            <div className="mt-6 space-y-3">
              {ticket.comentarios.map(item => (
                <article key={item.id} className="rounded-xl border border-[rgba(var(--border),0.6)] bg-[rgba(var(--subpanel),0.6)] p-4 text-sm text-[rgb(var(--fg))]">
                  <div className="flex items-center justify-between">
                    <span className="font-semibold">{item.autorTipo}</span>
                    <time className="text-xs text-[rgba(var(--muted),0.9)]">{new Date(item.creadoEn).toLocaleString()}</time>
                  </div>
                  <p className="mt-2 text-sm text-[rgba(var(--muted),0.95)]">{item.mensaje}</p>
                  {item.privado ? (
                    <span className="mt-2 inline-flex rounded-full bg-amber-500/20 px-2 py-0.5 text-xs font-semibold text-amber-500">Privado</span>
                  ) : null}
                </article>
              ))}
            </div>
          </div>
        )}

        {portalTicket?.puedeComentar ? (
          <form onSubmit={handleAddComment} className="rounded-2xl border border-[rgba(var(--border),0.6)] bg-[rgba(var(--panel),0.98)] p-6 shadow-xl">
            <Field label="Agregar comentario" htmlFor="comentarioPortal">
              <textarea
                id="comentarioPortal"
                rows={4}
                value={comentario}
                onChange={event => setComentario(event.target.value)}
                className="w-full rounded-xl border border-[rgba(var(--border),0.6)] bg-[rgba(var(--subpanel),0.6)] px-3 py-2 text-sm text-[rgb(var(--fg))] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
              />
            </Field>
            <div className="mt-4 flex justify-end">
              <button
                type="submit"
                className="rounded-xl bg-[rgb(var(--brand))] px-4 py-2 text-sm font-semibold text-white shadow focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
              >
                Enviar comentario
              </button>
            </div>
          </form>
        ) : null}
      </section>

      <StickyActions>
        <span className="text-xs text-[rgba(var(--muted),0.9)]">Seguimiento transparente para el cliente</span>
      </StickyActions>
    </div>
  );
}
